import { FC, useState } from 'react';

import { Alert, Button, ButtonStack, Text } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { fetchReBalance } from 'components/common/BalanceCardContent/BalanceCardTop/AdditionalActions/fetchReBalance';

import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    title: 'Header.HeaderBalanceDrop.AdditionalActions.reBalance.alert.title',
    description: 'Header.HeaderBalanceDrop.AdditionalActions.reBalance.alert.description',
    confirm: 'Header.HeaderBalanceDrop.AdditionalActions.reBalance.alert.confirm',
    cancel: 'Header.HeaderBalanceDrop.AdditionalActions.reBalance.alert.cancel',
};

interface ReBalanceAlertProps {
    visible: boolean;
    onClose: () => void;
}

export const ReBalanceAlert: FC<ReBalanceAlertProps> = ({ visible, onClose }) => {
    const [isLoading, setIsLoading] = useState(false);

    const trls = useTrls();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user.user);

    const handleConfirm = () => {
        void dispatch(
            fetchReBalance({
                setIsLoading,
                onClose,
            })
        );
    };

    return (
        <Alert
            visible={visible}
            onClose={onClose}
            title={trls(TrlKeys.title, [user?.name])}
            description={
                <Text typography="label-1-regular" style="secondary">
                    {trls(TrlKeys.description)}
                </Text>
            }
            buttons={
                <ButtonStack stretched layout="vertical">
                    <Button
                        mode="primary"
                        style="accent"
                        stretched
                        loading={isLoading}
                        disabled={isLoading}
                        onClick={handleConfirm}
                        data-qa="header-balance-drop-re-balance-confirm-button"
                    >
                        {trls(TrlKeys.confirm)}
                    </Button>
                    <Button
                        mode="secondary"
                        style="accent"
                        stretched
                        disabled={isLoading}
                        onClick={onClose}
                        data-qa="header-balance-drop-re-balance-cancel-button"
                    >
                        {trls(TrlKeys.cancel)}
                    </Button>
                </ButtonStack>
            }
        />
    );
};
